module.exports = __webpack_public_path__ + "img/181.bc452a6c.jpg";